import {
  FETCH_LESSONS_REQUEST,
  FETCH_LESSONS_SUCCESS,
  FETCH_LESSONS_FAILURE,
  CLEAR_LESSONS, //  Add this
} from "../Actions/lessonActions";

const initialState = {
  loading: false,
  lessons: [],
  error: null,
};

const fetchLessonReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LESSONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_LESSONS_SUCCESS:
      return {
        ...state,
        loading: false,
        lessons: action.payload,
      };
    case FETCH_LESSONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_LESSONS: // Handle clear action
      return {
        ...state,
        lessons: [],
        error: null,
      };
    default:
      return state;
  }
};

export default fetchLessonReducer;
